import React from 'react'
import './mech.css'

function Mech() {
    return (
        <div>
            <div className='mech-card'>
            <div className='flip-card-mech'>
                <div className='flip-card-inner-mech'>
                    <div className='flip-card-front-mech'>
                        <h1>
                        <br/>
                            Engineering Mechanics
                        </h1>
                    </div>
                    <div class="flip-card-back-mech">
                        <h3>
                            <a href='https://youtube.com/playlist?list=PLDN15nk5uLiAyM7MbRBF1eIFC8y5vMRxI'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PL9RcWoqXmzaIp3_6Gd6wwAwMtenRhGrJw'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://1lib.in/book/3685153/1f3358'>Basic mechanics with engineering applications</a>
                            <br/>
                            <a href='https://1lib.in/book/2343960/1257a8'>Theory of Machines and Mechanisms</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-mech'>
                <div className='flip-card-inner-mech'>
                    <div className='flip-card-front-mech'>
                    <br/>
                        <h1>
                        <br/>
                            Thermodynamics
                        </h1>
                    </div>
                    <div class="flip-card-back-mech">
                        <h3>
                            <a href='https://youtube.com/playlist?list=PLDDfbf7FIeqsPqMnCiU6dvkb6TbG21ucz'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PL9RcWoqXmzaK6AHCCyL_J6gqc02RN-w-D'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://www.pdfdrive.com/themodynamics-by-p-k-nag-e192969932.html'>Thermodynamics By PK Nag</a>
                            <br/>
                            
                            <a href='https://1lib.in/book/2577672/f5df58'>Thermodynamics: An Engineering Approach 8th Edition</a>
                        </h3>
                    </div>
                </div>
            </div>
            <div className='flip-card-mech'>
                <div className='flip-card-inner-mech'>
                    <div className='flip-card-front-mech'>
                    <br/>
                        <h1>
                        <br/>
                            Heat Transfer
                        </h1>
                    </div>
                    <div class="flip-card-back-mech">
                    
                        <h3>
                            <a href='https://youtube.com/playlist?list=PL5F4F46C1983C6785'>Video Resource 1</a>
                            <br/>
                            <a href='https://youtube.com/playlist?list=PLNyPK_sfNdSTiAczWmvY3tq33yWh_IHL2'>Video Resource 2</a>
                        </h3>
                        <h3>
                            <a href='https://www.pdfdrive.com/heat-and-mass-transfer-by-kothadaraman-e29924786.html'>Heat and Mass Transfer by Kothadaraman</a>
                            <br/>
                            <a href='https://1lib.in/book/1186756/74fe28'>Heat Transfer-McGraw-Hill Series</a>
                        </h3>
                    </div>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Mech
